module.exports = __webpack_public_path__ + "img/rocket.2a294edb.svg";